// TODO: this will be deprecated at some point
type APIMessage = {
  code: string;
  kind: 'APIMessage';
  source: string;
  text: string;
};

type JSONAPIMessage = {
  code: string;
  source: string;
  text: string;
};

const fromJSON = (jsonAPIMessage: JSONAPIMessage): APIMessage => ({
  code: jsonAPIMessage.code,
  kind: 'APIMessage',
  source: jsonAPIMessage.source,
  text: jsonAPIMessage.text,
});

// These are the five most common warnings. None of them are actionable.
// We hid them as part of this ticket https://shippo.atlassian.net/browse/ENG-35089
const hiddenCarrierMessages: Partial<Record<string, Set<string>>> = {
  DHLExpress: new Set([
    "Shippo's DHL Express master account doesn't support shipments to inside of the US",
  ]),
  ShippoCommon: new Set([
    'Shipment origin or destination state is out of the service area for LSO.',
  ]),
  UPS: new Set([
    'RatedShipmentAlert: Ship To Address Classification is changed from Commercial to Residential',
    'Shipment origin is out of service area for UPS Master account from CA',
    'RatedShipmentAlert: Your invoice may vary from the displayed reference rates',
  ]),
};

export const messageIsHidden = (message: { source: string; text: string }): boolean =>
  !!hiddenCarrierMessages[message.source]?.has(message.text);

export const messageIsVisible = (message: { source: string; text: string }): boolean =>
  !messageIsHidden(message);

const internationalCarrierAccountKeywords = [
  'chronopost',
  'sendle',
  'dpd_de',
  'correos',
  'deutsche_post',
  'canada_post',
  'dpd_uk',
  'colissimo',
  'hermes_uk',
  'couriersplease',
  'fastway',
  'royalmailsf',
  'mondial_relay',
  'poste_italiane',
  'parcelforce',
];

export const messageIsFromInternationalCarrier = (message: { text: string }): boolean => {
  // Only inspect the account token in the stable "Carrier account <account> ..." shape, so an
  // unrelated message that merely contains a carrier name (e.g. a "Sendle" street) isn't hidden.
  const account = /carrier account (\S+)/i.exec(message.text)?.[1]?.toLowerCase();
  if (!account) return false;
  return internationalCarrierAccountKeywords.some((keyword) => account.includes(keyword));
};

export const messageIsVisibleForShipment = (
  message: { source: string; text: string },
  { isDomestic }: { isDomestic: boolean },
): boolean =>
  messageIsVisible(message) && !(isDomestic && messageIsFromInternationalCarrier(message));

export default APIMessage;
export { APIMessage, JSONAPIMessage, fromJSON };
